@if (paramMap$ | async; as paramMap) {
	<article class="error-page">
		<div class="wrapper">
			<span class="h5 title">{{ paramMap.get("title") }}</span>
			<div class="error">{{ paramMap.get("message") }}</div>
			<footer>
				<div class="footer">
					<span class="img stages"></span>
				</div>
			</footer>
		</div>
	</article>
}
